import { render, staticRenderFns } from "./ContractWork.vue?vue&type=template&id=973c2b0a"
import script from "./ContractWork.vue?vue&type=script&lang=js"
export * from "./ContractWork.vue?vue&type=script&lang=js"
import style0 from "./ContractWork.vue?vue&type=style&index=0&id=973c2b0a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports